// eslint-disable-next-line no-unused-vars
import api from './api'
import meta from './modules/meta'
import standard from './modules/standard'

export default (resource) => {
  return {
    namespaced: true,
    modules: {
      meta: meta(),
      standard: standard(resource),
    },
    state: {
      tags: [],
    },
    getters: {
      tags: state => state.tags,
    },
    mutations: {
      setTags: (state, tags) => {
        state.tags = tags.sort((a, b) => a.name.localeCompare(b.name))
      }
    },
    actions: {
      addTagToContact: async ({commit}, payload) => {
        const contactId = payload.contactId
        const url = `/${resource}/${contactId}/tag`
        const {data} = await api.post(url, payload)
        commit('SET_OR_UPDATE_ITEM', data)
      },
      removeTagFromContact: async ({commit}, {contactId, tagId}) => {
        const url = `/${resource}/${contactId}/tag/${tagId}`
        const {data} = await api.delete(url)
        commit('SET_OR_UPDATE_ITEM', data)
      },
      readContactTagCollection: async ({commit}) => {
          const {data:{data}} = await api.get(`/ContactTags?pageSize=9999`)
          commit('setTags', data)
      },
      createContactTag: async ({dispatch}, payload) => {
        const {data: newTag} = await api.post(`/ContactTags`, payload)
        await dispatch('readContactTagCollection')
        return newTag
      },
      updateContactTag: async ({dispatch}, payload) => {
        await api.put(`/ContactTags/${payload.id}`, payload)
        await dispatch('readContactTagCollection')
      },
      deleteContactTag: async ({dispatch}, payload) => {
        await api.delete(`/ContactTags/${payload.id}`)
        await dispatch('readContactTagCollection')
        await dispatch('readCollection')
      }
    },
  }
}
